<template>
  <div>
   
    <autoLogout />
    <div class="wrapper-content">
      <encabezado :elementos="encabezado" />
      <v-card>
        <div class="container">
          <v-subheader>Información del Rol</v-subheader>
          <v-divider class="mb-5"></v-divider>
          <br />
          <validation-observer ref="form" v-slot="{ invalid }">
            <v-row>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  name="Nombre del Rol"
                  rules="required|max:150"
                >
                  <v-text-field
                    v-model="roleName"
                    :counter="150"
                    :error-messages="errors"
                    label="Nombre del Rol"
                    required
                    autocomplete="off"
                  ></v-text-field>
                </validation-provider>
              </v-col>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  name="Descripción de Rol"
                  rules="required|max:150"
                >
                  <v-text-field
                    v-model="roleDescription"
                    :counter="150"
                    :error-messages="errors"
                    label="Descripción del Rol"
                    required
                    autocomplete="off"
                  ></v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <br />

            <v-subheader>Permisos del Rol</v-subheader>
            <v-divider class="mb-5"></v-divider>
            <div v-show="true">
              <!-- v-model="objAddDate.idPatient" -->
              <!-- {{modelModule}} -->
              <div class="row">
                <div class="col-md-4">
                  <!-- @change="loadPermissions" -->

                  <v-autocomplete
                    :items="modules"
                    v-model="modelModule"
                    label="Módulo"
                    prepend-icon="mdi-account"
                    required
                    no-data-text="Sin resultados disponibles"
                    clearable
                    auto-select-first
                  ></v-autocomplete>
                </div>
                <div class="col-md-8">
                  <div class="row">
                    <div class="col-md-10">
                      <v-text-field
                        v-model="searchPermission"
                        append-icon="mdi-magnify"
                        label="Buscar"
                        single-line
                        hide-details
                        class="mx-5 mb-3"
                      />
                    </div>
                    <div class="col-md-2">
                      <v-switch
                        :disabled="
                          sending ||
                          modelModule == null ||
                          !modelModule.permissions
                        "
                        label="Todo"
                        v-model="all"
                        @click="setAllPermissions"
                        hide-details
                      ></v-switch>
                    </div>
                  </div>

                  <v-data-table
                    :headers="headersPermissions"
                    :items="modelModule != null ? modelModule.permissions : []"
                    :search="searchPermission"
                    :items-per-page="10"
                    :footer-props="{
                      'items-per-page-text': 'Elementos por página',
                      'items-per-page-all-text': 'Todo',
                    }"
                    no-results-text="Sin resultados coincidentes con el búsqueda"
                    loading-text="Cargando..."
                    no-data-text="Sin resultados disponibles"
                    class="mx-5"
                    dense
                    fixed-header
                    height="auto"
                  >
                    <template v-slot:[`item.description`]="{ item }">
                      <span
                        :class="{
                          'font-italic font-weight-bold': item.type == 2,
                        }"
                      >
                        {{ item.description }}
                      </span>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <!-- <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }"> -->
                      <v-checkbox
                        v-model="item.assign"
                        hide-details
                        dense
                        @click="updateAll"
                        :disabled="sending"
                      />
                      <!-- <v-checkbox v-model="item.assign"  v-bind="attrs" v-on="on" :disabled="sending"/>  -->
                      <!-- </template>
                          <span>Asignar {{item.idPermission}}</span>
                        </v-tooltip>                          -->
                    </template>
                  </v-data-table>
                </div>
              </div>
              <div class="d-flex justify-center">
                <v-col class="d-flex justify-space-around">
                  <v-btn
                    type="button"
                    color="error"
                    @click="backRoute"
                    :disabled="sending"
                  >
                    <v-icon left>mdi-close</v-icon>
                    Volver
                  </v-btn>
                  <v-btn
                    type="submit"
                    :disabled="sending || invalid"
                    color="success"
                    @click="save"
                  >
                    <v-icon left>mdi-content-save</v-icon>
                    Guardar
                  </v-btn>
                </v-col>
              </div>
            </div>
          </validation-observer>

          <div v-show="false">
            <br />
            <v-row>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details
                class="mx-5 mb-3"
              ></v-text-field>
              <v-col cols="2"></v-col>
              <v-col cols="1" v-if="edit" @click="editarRoles()">
                <btn-accion :elements="btnEdit" />
              </v-col>
              <v-col cols="1" v-if="!edit" @click="statusOk()">
                <btn-accion :elements="btnEdit2" />
              </v-col>
              <v-col cols="3"></v-col>
            </v-row>
            <br />
            <v-row align="center">
              <div class="col-md-2" v-for="post in filteredList" :key="post.id">
                <v-checkbox
                  v-model="permission[`${post.idPermission - 1}`]"
                  :label="post.description"
                  :disabled="sending"
                  @click="modificar(post.idPermission)"
                ></v-checkbox>
              </div>
            </v-row>
            <v-btn
              v-scroll="onScroll"
              v-show="fab"
              fab
              dark
              fixed
              bottom
              right
              color="primary"
              @click="toTop"
            >
              <v-icon>mdi-arrow-up</v-icon>
            </v-btn>
          </div>
        </div>
        <v-dialog v-model="dialog" persistent max-width="450">
          <v-card>
            <v-card-title class="text-h6 text-center">
              ¿Desea modificar los permisos del rol?
            </v-card-title>
            <v-card-text
              >Los permisos serán Habilitados / Inhabilitados de inmediato, lo
              que podría afectar a los usuarios que dependan de
              estos</v-card-text
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" text @click="dialog = false">
                Cancelar
              </v-btn>
              <v-btn
                color="primary"
                text
                @click="
                  dialog = false;
                  statusOk();
                "
              >
                Aceptar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import Datatable from "../../components/Datatable.vue";
import Encabezado from "@/app/components/base/header/Header.vue";
import Sidebar from "../../components/Sidebar";
import BtnAccion from "../../components/btnAccion.vue";
import {
  RolePermissionRequest,
  ModuleRequest,
  RoleRequest,
} from "@/core/request";
import { mapActions } from "vuex";
import AutoLogout from "../../components/AutoLogout.vue";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";

export default {
  name: "Estudio",
  components: {
    Sidebar,
    Encabezado,
    Datatable,
    BtnAccion,
    AutoLogout,
    ValidationObserver,
    ValidationProvider,
  },
  data: () => ({
    fab: false,
    search: "",
    roleName: "",
    roleDescription: "",
    idRole: "",
    sending: false,
    dialog: false,
    edit: true,
    encabezado: { icono: "mdi-account-key", texto: "Permisos del Rol" },
    list: [],
    listPermissions: [],
    permission: [],
    btnEdit: {
      icon: "mdi-key-plus",
      text: "Editar Permisos",
      tooltip: "Editar permisos",
    },
    btnEdit2: {
      icon: "mdi-key-remove",
      text: "Guardar Permisos",
      tooltip: "Guardar permisos",
      color: "success",
    },
    service: RolePermissionRequest,
    serviceModule: ModuleRequest,
    modules: [],
    modelModule: {},
    headersPermissions: [
      { text: "Id Permiso", value: "idPermission" },
      { text: "Nombre", value: "description" },
      { text: "Asignar", value: "actions", sortable: false },
    ],
    searchPermission: "",
    listPermissionsModule: [],
    all: false,
  }),
  beforeMount() {
    // this.getPermissions();
  },
  mounted() {
    this.validBrowserTab();
    // this.getPermissionsByRol();
    this.listAllWithPermissions();
    this.getRol();
  },
  watch: {
    modelModule: function (newVal, oldVal) {
      if (newVal != null) {
        this.updateAll();
      }
    },
  },
  methods: {
    ...mapActions(["validTab", "unauthorized"]),
    validBrowserTab() {
      this.validTab();
    },
    catchError: (e) => {
      //console.log(e);
      this.$utilFront.notifications("Ha ocurrido un error interno", "ERROR");
    },
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 200;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
    getPermissionsByRol() {
      let id = localStorage.getItem("idRole");
      let post = {
        idRole: id,
      };
      RolePermissionRequest.getPermissionsByRol(post).then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.roleName = res.data.data[0].role.name;
          this.roleDescription = res.data.data[0].role.description;
          this.idRole = res.data.data[0].role.idRole;
          this.listPermissions = res.data.data.map((permissionRol) => {
            return {
              idPermission: permissionRol.permission.idPermission,
            };
          });
        }
        for (let i = 0; i < this.list.length; i++) {
          let flag = false;
          for (let j = 0; j < this.listPermissions.length; j++) {
            if (
              this.list[i].idPermission === this.listPermissions[j].idPermission
            ) {
              flag = true;
              break;
            }
          }
          this.permission.push(flag);
        }
      });
    },
    getPermissions() {
      RolePermissionRequest.getPermissions().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.list = res.data.data.map((permission) => {
            return {
              idPermission: permission.idPermission,
              description: permission.description,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    modificar(id) {
      if(!this.sending){
      this.sending = true;
      let postData = {
        permission: {
          idPermission: id,
        },
        role: {
          idRole: this.idRole,
        },
      };

      if (this.permission[id - 1]) {
        RolePermissionRequest.addRolePermission(postData).then((res) => {
          if (res.data.data) {
            if (res.data.code === 200 && res.data.status === "OK") {
              this.$utilFront.notifications(
                "Permiso asignado correctamente",
                "SUCCESS"
              );
            } else if (res.data.code === 401) {
              this.unauthorized();
            } else {
              this.$utilFront.notifications(
                "Sucedio un error al asignar el permiso",
                "ERROR"
              );
            }
          }
        }).finally(() => {
          this.sending = false;
        });
      } else {
        RolePermissionRequest.removeRolePermission(postData).then((res) => {
          if (res.data.data) {
            if (res.data.code === 200 && res.data.status === "OK") {
              this.$utilFront.notifications(
                "Permiso eliminado correctamente",
                "SUCCESS"
              );
            } else if (res.data.code === 401) {
              this.unauthorized();
            } else {
              this.$utilFront.notifications(
                "Sucedio un error al eliminar el permiso",
                "ERROR"
              );
            }
          }
        }).finally(() => {
          this.sending = false;
        });
      }
      }
    },
    editarRoles() {
      this.dialog = true;
    },
    statusOk() {
      this.sending = !this.sending;
      this.edit = !this.edit;
    },

    /*Todo: refc*/
    listAllWithPermissions() {
      let id = localStorage.getItem("idRole");
      this.modules = [];
      this.serviceModule
        .listAllWithPermissionsWithRol({ idRole: id })
        .then((res) => {
          let { data, response, message } = res.data;
          if (response) {
            this.modules = data.map((it) => {
              return { text: it.name, value: it };
            });
            this.modelModule = this.modules[0].value;
          }
        });
    },
    setAllPermissions() {
      if (this.modelModule && this.modelModule.permissions) {
        this.modelModule.permissions = this.modelModule.permissions.map(
          (it) => {
            it.assign = this.all;
            return it;
          }
        );
      }
    },
    updateAll() {
      this.all = false;
      let filtered = this.modelModule.permissions.filter(function (it) {
        return it.assign == true;
      });
      this.all =
        filtered.length == this.modelModule.permissions.length &&
        this.modelModule.permissions.length > 0;
    },
    getRol() {
      let id = localStorage.getItem("idRole");
      RoleRequest.getRol({ idRole: id }).then((res) => {
        let { data, response, message } = res.data;
        if (response) {
          this.roleName = data.name;
          this.roleDescription = data.description;
          this.idRole = data.idRole;
        }
      });
    },
    backRoute() {
      this.sending = true;
      this.$router.go(-1);
    },
    save() {
      this.sending = true;
      let permissionsList = [];
      for (let i = 0; i < this.modules.length; i++) {
        permissionsList = permissionsList.concat(
          this.modules[i].value.permissions
        );
      }
      permissionsList = permissionsList.map((prm) => {
        return { idPermission: prm.idPermission, assign: prm.assign };
      });

      let data = {
        idRole: this.idRole,
        permissions: permissionsList,
      };

      this.service
        .save(data)
        .then((res) => {
          let { data, response, message } = res.data;
          if (response) {
          } else {
            message = message || "Ocurrió un error al guardar.";
            this.$utilFront.notifications(message, "ERROR");
          }
        })
        .finally(() => {
          this.updateRole();
        });
    },
    updateRole() {
      this.sending = true;

      let data = {
        idRole: this.idRole,
        name: this.roleName,
        description: this.roleDescription,
      };

      RoleRequest.updateRole(data)
        .then((res) => {
          if (res.data.code === 200 && res.data.status === "OK") {
            this.$utilFront.notifications(
              "Se ha modificado correctamente.",
              "SUCCESS"
            );
          } else {
            let message = "Ocurrió un error al guardar. " + res.data.data;
            this.$utilFront.notifications(message, "ERROR");
          }
        })
        .finally(() => {
          this.sending = false;
          this.backRoute()
        });
    },
  },
  computed: {
    filteredList() {
      return this.list.filter((post) => {
        return post.description
          .toLowerCase()
          .includes(this.search.toLowerCase());
      });
    },
  },
};
</script>